import React from 'react';
import { Empty } from 'antd';
import BaseError from '../../../../../../components/BaseError';
import {
  useAcceptanceListInfo,
  useParsedAcceptanceSlug,
} from '../../../../services/queries/acceptanceData';

const emptyMap = new Map();

const AcceptanceIdValidator = ({ children }) => {
  const { acceptanceId, houseId } = useParsedAcceptanceSlug();

  const { data: acceptances = emptyMap } = useAcceptanceListInfo({
    dataType: useAcceptanceListInfo.dataTypes.map,
  });

  if (isNaN(acceptanceId)) {
    return <BaseEmpty description="Выберите приемку" />;
  }

  if (acceptances === 'Error' || acceptances.size === 0) {
    return null;
  }

  const acceptance = acceptances.get(acceptanceId);

  if (!acceptance) {
    return (
      <BaseError description="Выбранная приемка отсутствует в текущем списке приемок" />
    );
  }

  if (houseId !== undefined && !acceptance.houses?.has(houseId)) {
    return <BaseError description="Выбранный дом отсутствует в приемке" />;
  }

  return children;
};

export default AcceptanceIdValidator;

function BaseEmpty({ description }) {
  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />
  );
}
